import { apiClient } from "./client";

export type PresenceVisibility = "online" | "away" | "busy" | "offline";
export type PresenceEffectiveStatus = PresenceVisibility;

export interface PresenceStatus {
  userId: string;
  visibility: PresenceVisibility;
  effectiveStatus: PresenceEffectiveStatus;
  online: boolean;
  lastSeen: string;
  updatedAt: string;
}

export async function listPresence(userIds: string[]): Promise<{ items: PresenceStatus[] }> {
  const ids = Array.from(new Set(userIds.filter(Boolean))).slice(0, 100);
  const params = ids.length > 0 ? `?ids=${encodeURIComponent(ids.join(","))}` : "";
  return apiClient.get<{ items: PresenceStatus[] }>(`/api/presence${params}`);
}

export async function updatePresenceVisibility(visibility: PresenceVisibility): Promise<PresenceStatus> {
  return apiClient.put<PresenceStatus>("/api/user/presence", { visibility });
}

export async function heartbeatPresence(idleSince?: string | null): Promise<PresenceStatus> {
  return apiClient.post<PresenceStatus>("/api/user/presence/heartbeat", { idleSince: idleSince ?? null });
}
